import { z } from 'zod';
import { TenantIdSchema } from '../types/common.types';

/**
 * Rental handover-photo szerződések (E-105 Phase 3, Wave-2 BE-1).
 *
 * Tárolás: a meglévő `Document` model (polimorf `sourceType`/`sourceId` +
 * `storageKey` MinIO + DocumentAudit + retention, ADR-092) — NINCS dedikált
 * `RentalHandoverPhoto` tábla, így zéró schema-migráció. A handover-fotó egy
 * `Document` rekord: `sourceType='RENTAL_HANDOVER_PHOTO'`, `sourceId=rentalId`.
 */

// A fotó fázisa: felvétel (kiadáskor) vagy visszavétel (returnkor).
export const HandoverPhotoKindSchema = z.enum(['HANDOVER', 'RETURN']);
export type HandoverPhotoKind = z.infer<typeof HandoverPhotoKindSchema>;

// Egy tárolt handover-fotó — a FE ezt a metaadatot kapja vissza (a bináris a
// külön GET .../handover-photos/:photoId/content végponton tölthető).
export const RentalHandoverPhotoSchema = z.object({
  id: z.string().uuid(), // a háttér Document.id
  tenantId: TenantIdSchema,
  rentalId: z.string().uuid(), // Document.sourceId
  kind: HandoverPhotoKindSchema,
  fileName: z.string().min(1).max(255),
  contentType: z.string().min(1).max(127),
  sizeBytes: z.number().int().nonnegative(),
  uploadedAt: z.string().datetime(),
  uploadedBy: z.string().uuid().nullable(),
});
export type RentalHandoverPhoto = z.infer<typeof RentalHandoverPhotoSchema>;

// Upload metaadat — a `kind` a multipart form-mezőből (a fájl maga multipart,
// nem Zod-body); a controller ezt a fájl mellől parse-olja.
export const HandoverPhotoUploadMetaSchema = z.object({
  kind: HandoverPhotoKindSchema,
});
export type HandoverPhotoUploadMeta = z.infer<typeof HandoverPhotoUploadMetaSchema>;

// Upload válasz — a létrejött fotó-rekord ({ data } konvenció).
export const HandoverPhotoUploadResponseSchema = z.object({
  data: RentalHandoverPhotoSchema,
});
export type HandoverPhotoUploadResponse = z.infer<typeof HandoverPhotoUploadResponseSchema>;

// Lista válasz egy bérléshez.
export const HandoverPhotoListResponseSchema = z.object({
  data: z.array(RentalHandoverPhotoSchema),
});
export type HandoverPhotoListResponse = z.infer<typeof HandoverPhotoListResponseSchema>;

// Lista query — opcionális fázis-szűrő.
export const HandoverPhotoListQuerySchema = z.object({
  kind: HandoverPhotoKindSchema.optional(),
});
export type HandoverPhotoListQuery = z.infer<typeof HandoverPhotoListQuerySchema>;
